<template>
          <div class="choices">
            <div class="choice" v-for="choice,choiceIndex in question.answers_multiple" >
              <button :disabled="question.commited"  @click="selectAcceptableAnswer(question,choiceIndex, true)" :class="{'selected': choice.selected === true, 'correct': choice.is_correct === true && question.commited,'incorrect': choice.is_correct===false && question.commited  }">✔</button>
              <button :disabled="question.commited"  @click="selectAcceptableAnswer(question,choiceIndex, false)" :class="{'selected': choice.selected === false, 'correct': choice.is_correct === false && question.commited,'incorrect': choice.is_correct===true && question.commited  }">✖</button>
              <span class="questionLetter">({{String.fromCharCode(choiceIndex+65)}})</span> <span v-html="choice.answer"></span>
            </div>
            <div v-if="question.commited && question.correct && paid" class="congratulations">
              Your answer is correct!
            </div>
            <div v-if="question.commited && !question.correct && paid" class="sorry">
              Your answer is incorrect. Answers that need changing {{currentAcceptableQuestionAnswer}}
            </div>
            <div v-if="question.commited && !paid">Answer submitted. Click Continue to proceed.</div>
            <button v-if="!question.commited" @click="answerMultipleChoice(question)">Submit</button>
            <button v-if="question.commited && question.explanation_input" @click="showExplanation=true">Show Explanation</button>
          </div>
</template>

<script>
import Vue from 'vue'
    export default {
          name: 'acceptable-statement',
          props: ['question', 'paid'],

          data(){
            return {

            }
          },
          methods:{
            selectAcceptableAnswer: function(question, choiceIndex, selected){
              var vm = this;
              question.answers_multiple[choiceIndex].selected = selected;
              Vue.set(question.answers_multiple, choiceIndex, vm.question.answers_multiple[choiceIndex]);
            },
            answerMultipleChoice: function(question){
                console.log('emitting answer');
                this.$emit('answer', {question} );
            }
          },
          computed: {
            currentAcceptableQuestionAnswer: function(){
              var vm = this;
              var question = vm.question;

              console.log('question', question);
              var correctArray = [];
              var incorrectArray = [];

              for (var i = 0; i < question.answers_multiple.length; i++) {
                  console.log(question.answers_multiple[i]);

                  if(question.answers_multiple[i].is_correct && !question.answers_multiple[i].selected){
                    correctArray.push(String.fromCharCode(i+65) + '-✔');
                  } else if ( !question.answers_multiple[i].is_correct && question.answers_multiple[i].selected) {
                    correctArray.push(String.fromCharCode(i+65) + '-✖' );
                  }

              }

              return correctArray.join(', ');


            }
          }
    }
</script>


// WEBPACK FOOTER //
// AcceptableStatement.vue?136bae43